/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import { gql } from '@apollo/client';

const mutation = gql`
  mutation PavillonSearchCustomerSalesRightsMutation($input: PavillonSearchCustomerSalesRights_M_simulation_customer_granteesInput!) {
    pavillonSearchCustomerSalesRights_M_simulation_customer_grantees(input: $input) {
      ok
      error
      
        code 
    }
  }
`;

export default mutation;
